module.exports = __webpack_public_path__ + "static/media/cryptoiz.9fb3f909.png";